export const setPayoutsPreview = {
  SET_PAYOUTS_PREVIEW(state, payload) {
    state.payoutsPreview = payload;
  }
};
